module.exports = __webpack_public_path__ + "img/personal_training.4a85b598.png";